/**
 * Whether a coach has a name to show. A coach that has not finished onboarding may have none, and listing or sorting
 * coaches by name throws on it.
 * @param {*} name - The coach's name, as stored.
 * @returns {boolean} True for a name with something other than whitespace in it.
 */
const hasCoachName = (name) => typeof name === 'string' && name.trim() !== '';

export default hasCoachName;
